import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from './api.ts';

// Live updates: poll one tiny counter every few seconds while the tab is visible; refetch only when it moves.
// (Cheaper than a held-open stream on scale-to-zero Cloud Run, and well inside Firestore's free tier.)
export function useLiveUpdates(intervalMs = 4000) {
  const qc = useQueryClient();
  useEffect(() => {
    let last: number | null = null;
    let stop = false;
    const tick = async () => {
      if (stop) return;
      if (document.visibilityState === 'visible') {
        try {
          const { version } = await api<{ version: number }>('/changes');
          if (last !== null && version !== last) await qc.invalidateQueries();
          last = version;
        } catch { /* offline or signed out: try again next tick */ }
      }
      setTimeout(tick, intervalMs);
    };
    tick();
    const onVis = () => { if (document.visibilityState === 'visible') qc.invalidateQueries(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { stop = true; document.removeEventListener('visibilitychange', onVis); };
  }, [qc, intervalMs]);
}
